// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_92-3";
export var contentContainer = "_92-0";
export var editorContainer = "_92-1";
export var quillInputForm = "_92-2";
export var zoneDivider = "_92-4";